module.exports = __webpack_public_path__ + "static/scale-model-of-oil-derrick-in-arlington-texas-87ab56b9f2ab37308dd03792ffcf6c35.png";